import { Platforms } from './types';

export const Z_INDEX = {
  DROPDOWN: 4, // Dropdown lists
  STICKY: 5, // Sticky elements: mobile form header, bottom drawers
  HINT: 6, // Tooltips and hints
  HEADER: 10, // Desktop header bar
  MODAL: 7, // Default modal level
  HEADER_DROPDOWN: 9, // Header menus, photo actions, sticky bottom bar
  NAVIGATION: 10, // Navigation submenus, priority modals
  MODAL_HIGH: 99999, // High-priority overlays: PaymentModal, header menu overlay
  MODAL_TOP: 100000 // Topmost modal: TerminalModal
} as const;

export const DESCRIPTION_CHAR_LIMIT = 3000;
export const HALF_SELECT_LIST_HEIGHT = 140;
export const SCROLL_TO_ERROR_TIMEOUT = 200;
export const MILEAGE_MAX_LENGTH = 7;
export const FRIENDLY_SITES = ['Tap.az', 'Bina.az', 'Boss.az'];

export const POND_URL = `${process.env.POND_SERVER_URL}/pond`;
export const API = {
  MAKES: '/api/v2/properties/makes.json',
  PROPERTIES: '/api/v2/properties/options.json',
  PROPERTIES_EDIT: '/api/v2/autos/new.json',
  PROFILE: '/api/v2/profile.json',
  LOGIN: '/session/login.json',
  LOGOUT: '/session/logout',
  CATALOG: '/api/v2/catalog/form_data.json',
  NEW_AD: '/api/v2/autos.json',
  CHANGE_REQUESTS: (adId: string) => `/api/v2/autos/${adId}/edit_request/new`,
  CATALOG_FIELD_DATA: (catalogItemId: string) => `/api/v2/catalog/${catalogItemId}/form_data`,
  EDIT_REQUEST: (adId: string) => `/api/v2/autos/${adId}/edit_request.json`,
  PROLONG_WITHOUT_CHANGES_REQUEST: (adId: string) => `/api/v2/autos/${adId}/prolongate/check`,
  RESET_HISTORY: (adId: string) => `/api/v2/autos/${adId}/prolongate/reset_history`,
  BALANCE_PAYMENT: (adId: string) => `/api/v2/autos/${adId}/prolong`,
  PAYMENT: (adId: string) => `/api/v2/autos/${adId}/payments`
};

export const BREAKPOINTS = {
  mobile: '600px',
  tablet: '768px',
  desktop: '1279px'
};

export const rusKeyToLat: Record<string, string> = {
  й: 'q',
  ц: 'w',
  у: 'e',
  к: 'r',
  е: 't',
  н: 'y',
  г: 'u',
  ш: 'i',
  щ: 'o',
  з: 'p',
  х: '[',
  ъ: ']',
  ф: 'a',
  ы: 's',
  в: 'd',
  а: 'f',
  п: 'g',
  р: 'h',
  о: 'j',
  л: 'k',
  д: 'l',
  ж: ';',
  э: "'",
  я: 'z',
  ч: 'x',
  с: 'c',
  м: 'v',
  и: 'b',
  т: 'n',
  ь: 'm',
  б: ',',
  ю: '.',
  Й: 'Q',
  Ц: 'W',
  У: 'E',
  К: 'R',
  Е: 'T',
  Н: 'Y',
  Г: 'U',
  Ш: 'I',
  Щ: 'O',
  З: 'P',
  Х: '{',
  Ъ: '}',
  Ф: 'A',
  Ы: 'S',
  В: 'D',
  А: 'F',
  П: 'G',
  Р: 'H',
  О: 'J',
  Л: 'K',
  Д: 'L',
  Ж: ':',
  Э: '"',
  Я: 'Z',
  Ч: 'X',
  С: 'C',
  М: 'V',
  И: 'B',
  Т: 'N',
  Ь: 'M',
  Б: '<',
  Ю: '>'
};

export const PlatformsList: Platforms = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
};

export const SITE_LINKS = {
  HELP: '/help/popular_questions',
  TERM_AND_CONDITIONS: '/pages/terms-and-conditions',
  PRIVACY: '/pages/privacy',
  RULES: '/pages/rules',
  ORDER: '/pages/order-recommendations',
  LAW: '/pages/law',
  PROPOSAL: '/pages/proposal'
};

export const TOP_LIST_COUNT = 20;
